"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineHomepageSlide1 = exports.HomepageSlide1 = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
class HomepageSlide1 extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
    <style>
      :host {
        display: grid;
        grid-template-columns: 3fr 2fr;
        background-image: linear-gradient(#d4b69a, #cfac8e);
        box-sizing: border-box;
        width: 100%;
        max-width: var(--slide-max-width);
        margin: var(--main-frame-header-height) auto 0; /* to prevents menu-bar covers the first slide on page loading. */
        aspect-ratio: 21 / 10;
        
        view-timeline-name: --slide-timeline;
        view-timeline-axis: block;
      }
      
      div.grid-cell-1 {
        display: grid;
        grid-template-rows: auto 1fr;
      }
      
      div.paragraph {
        color: #271106;
        font-family: 'quaaykop-medium', sans-serif;
      }
      
      @keyframes animate-paragraph {
        from {
          opacity: 1;        
          transform: translateX(0);
        }
        to {
          opacity: 0;
          transform: translateX(400px);
        }
      }
      
      div.paragraph div.title {
        font-size: 6rem;
        margin: 2rem 1rem 1rem 1.2rem;
        
        animation: animate-paragraph  cubic-bezier(0.18, 0.89, 0.32, 1.28);
        animation-timeline: --slide-timeline;
        animation-range: exit 0% exit 100%;
        animation-fill-mode: both;
      }
      div.paragraph div.sub-title {
        font-size: 3.2rem;
        font-weight: 500;
        line-height: 110%;
        margin-left: 1rem;
        margin-bottom: 1rem;
        
        animation: animate-paragraph  cubic-bezier(0.18, 0.89, 0.32, 1.28);
        animation-timeline: --slide-timeline;
        animation-range: exit 10% exit 100%;
        animation-fill-mode: both;
      }
      div.paragraph div.content {
        font-size: 1.75rem;
        line-height: 120%;
        margin-left: 1rem;
        
        animation: animate-paragraph  cubic-bezier(0.18, 0.89, 0.32, 1.28);
        animation-timeline: --slide-timeline;
        animation-range: exit 20% exit 100%;
        animation-fill-mode: both;
      }
      
      div.product-container {
        position: relative;
      }
      
      div.product-container div.product {
        display: flex;
        position: absolute;
        bottom: 2rem;
        right: 3rem;
        height: 80%;
        gap: 1rem;
      }
      
      div.woman-container {
        position: relative;
        height: 100%;
        overflow: hidden;
      }
      
      @keyframes animate-woman {
        from {
          transform: translateY(0);
        }
        to {
          transform: translateY(400px);
        }
      }
      div.woman-container img {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 90%;
        max-width: 600px;
        
        animation: animate-woman linear;
        animation-timeline: --slide-timeline;
        animation-range: exit 0% exit 100%;
        animation-fill-mode: both;
      }
      
      @media (max-width: 600px) {
        :host {
          display: flex;
          flex-direction: column;
          min-height: unset;
        }
        div.grid-cell-1 {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        div.paragraph div.title {
          font-size: 18vw;
        }
        div.paragraph div.sub-title {
          font-size: 8vw;
        }
        div.paragraph div.content {
          font-size: 5vw;
        }
        div.product-container div.product {
          position: unset;
          padding: 1rem 2rem;
          gap: unset;
          box-sizing: border-box;
          justify-content: space-evenly;
        }
        div.woman-container {
          display: none;
        }
      }
      
    </style>
    <div class="grid-cell-1">
      <div class="paragraph">
        <div class="title">AiLEENE</div>
        <div class="sub-title">THE MOST LUXURIOUS AND PERFECT FILLER IN THE WORLD</div>
        <div class="content">AiLEENE provides not only beauty but also the gifts of customer satisfaction and confidence.</div>
      </div>
      <div class="product-container">
        <div class="product">
          <img class="product cyan" src="/files/assets/images/aileene-product-cyan.png" />
          <img class="product purple" src="/files/assets/images/aileene-product-purple.png" />
          <img class="product red" src="/files/assets/images/aileene-product-red.png" />
        </div>
      </div>
    </div>
    <div class="woman-container">
      <img src="/files/assets/images/slide-1-background-woman.png" />
    </div>
    `;
    }
}
exports.HomepageSlide1 = HomepageSlide1;
const defineHomepageSlide1 = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, HomepageSlide1);
};
exports.defineHomepageSlide1 = defineHomepageSlide1;
